import { Field, Select } from "@/components/FormField";

const SUNLIGHT_OPTIONS = ["Full Sun", "Partial Sun", "Bright Indirect", "Low Light", "Not Sure"];
const YES_NO = ["No", "Yes"];
const MAINTENANCE_OPTIONS = ["Not sure", "Yes", "No"];

// Default group for Landscaping, Home/Terrace/Balcony Garden Consultation — anything not covered
// by a more specific ExtraFields component.
export default function GenericSpaceFields({ extra, updExtra }) {
  return (
    <>
      <div className="text-sm font-semibold text-[var(--yp-primary)] sm:col-span-2 -mb-2">Space Conditions</div>
      <Select id="sr-generic-sunlight" label="Sunlight" value={extra.sunlight || ""} onChange={(v) => updExtra("sunlight", v)} options={SUNLIGHT_OPTIONS} />
      <Select id="sr-generic-existing" label="Existing garden?" value={extra.existing_garden || ""} onChange={(v) => updExtra("existing_garden", v)} options={YES_NO} />
      <Field id="sr-generic-preference" label="Plant preference" value={extra.preference || ""} onChange={(v) => updExtra("preference", v)} placeholder="Flowering, foliage, fruit, easy-care..." />
      <Select id="sr-generic-maintenance" label="Maintenance support?" value={extra.maintenance || ""} onChange={(v) => updExtra("maintenance", v)} options={MAINTENANCE_OPTIONS} />
    </>
  );
}
